var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKiddyLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "prefix__Kiddy_-_Logo",
    width: 99,
    height: 30,
    "data-name": "Kiddy - Logo",
    viewBox: "0 0 99 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y1: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#22b560"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11763b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__linear-gradient-2",
    y1: 0,
    y2: 1,
    xlinkHref: "#prefix__linear-gradient"
  }), /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-3{fill:#d0d2d3}.prefix__cls-4{fill:#a6a8ab}.prefix__cls-6{fill:url(#prefix__linear-gradient-2)}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Shape",
    fill: "#6d6e70",
    d: "M21.127 17.675a6.7 6.7 0 0 1-4.992-2.136 7.339 7.339 0 0 1-1.9-5.01v-.038a7.368 7.368 0 0 1 1.919-5.029 6.9 6.9 0 0 1 10-.02 7.339 7.339 0 0 1 1.9 5.01v.039a7.367 7.367 0 0 1-1.919 5.029 6.736 6.736 0 0 1-5.008 2.155zm0-12.8a5.272 5.272 0 0 0-5.194 5.567v.038a5.858 5.858 0 0 0 1.474 3.97 5.015 5.015 0 0 0 3.752 1.65 5.272 5.272 0 0 0 5.194-5.567v-.038a5.858 5.858 0 0 0-1.474-3.97 5.015 5.015 0 0 0-3.752-1.652zm15.55 12.783a6.117 6.117 0 0 1-4.338-1.543 6.028 6.028 0 0 1-1.682-4.491V4.3a.832.832 0 0 1 1.664 0v7.226a4.715 4.715 0 0 0 1.159 3.416 4.331 4.331 0 0 0 3.234 1.169A4.336 4.336 0 0 0 39.892 15a4.582 4.582 0 0 0 1.159-3.38V4.3a.833.833 0 0 1 1.665 0v7.206c.002 3.852-2.256 6.152-6.039 6.152zM4.221 17.59a4.26 4.26 0 0 1-3.054-1.14A4.04 4.04 0 0 1 0 13.476v-.06c0-2.647 2.12-4.357 5.4-4.357h.151a15.562 15.562 0 0 1 4.264.6V8.392c0-2.212-1.461-3.533-3.909-3.533h-.187a7.656 7.656 0 0 0-4.13 1.21.816.816 0 0 1-.456.138H1.1a.8.8 0 0 1-.737-.814c0-.478.37-.715.7-.924l.012-.008A9.538 9.538 0 0 1 5.954 3.35h.123a6.542 6.542 0 0 1 3.223.855l1.862-1.825a.785.785 0 0 1 .6-.278.892.892 0 0 1 .872.888.749.749 0 0 1-.252.557L10.52 5.292a4.634 4.634 0 0 1 .986 2.938v8.534a.834.834 0 0 1-1.664 0v-5.6a16.207 16.207 0 0 0-4.249-.634c-2.509 0-3.891.994-3.891 2.8v.06a2.547 2.547 0 0 0 .7 1.93 2.774 2.774 0 0 0 1.975.65l.581-.019h.048a.7.7 0 0 1 .484.2.739.739 0 0 1 .224.531c-.003.618-.477.908-1.493.908zm42.491-.031h-.129a.761.761 0 0 1-.52-.206.808.808 0 0 1-.255-.571V4.438a.911.911 0 0 1 .872-.938h.12a1.193 1.193 0 0 1 .852.455l3.487 4.19a.8.8 0 0 1 .175.484.822.822 0 0 1-.813.814.71.71 0 0 1-.543-.26l-2.483-3.051v10.65a.791.791 0 0 1-.251.574.749.749 0 0 1-.512.203zm11.046-.02a.786.786 0 0 1-.536-.212.83.83 0 0 1-.261-.584V6.124l-2.5 3.058a.669.669 0 0 1-.521.259.868.868 0 0 1-.814-.832.737.737 0 0 1 .175-.436l3.522-4.229a1.144 1.144 0 0 1 .814-.454h.116a.91.91 0 0 1 .872.929v12.324a.794.794 0 0 1-.236.58.753.753 0 0 1-.528.216h-.048zm14.975 0a.826.826 0 0 1-.593-.256.864.864 0 0 1-.235-.638V5.093H68.48a5.488 5.488 0 0 0-4.034 1.545 5.435 5.435 0 0 0-1.464 3.853v.038a5.5 5.5 0 0 0 1.348 3.833 5.173 5.173 0 0 0 3.917 1.526.754.754 0 0 1 .654.387.793.793 0 0 1 0 .774.754.754 0 0 1-.654.387 6.877 6.877 0 0 1-5.078-2.008 7.015 7.015 0 0 1-1.891-4.939v-.039a6.827 6.827 0 0 1 7.2-6.908h4.336a.785.785 0 0 1 .758.794v12.306a.845.845 0 0 1-.215.629.8.8 0 0 1-.594.265zm-20.475-6.075a.932.932 0 0 1 0-1.864h.024a.878.878 0 0 1 .626.266.948.948 0 0 1-.65 1.6zM46.567 1.47a.675.675 0 0 1-.484-.207.706.706 0 0 1-.194-.537.708.708 0 0 1 .2-.522.668.668 0 0 1 .48-.2h11.315a.726.726 0 0 1 .716.731.726.726 0 0 1-.716.734H46.567z",
    transform: "translate(24.762 4.56)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Oval",
    d: "M.217.443A.219.219 0 0 0 .434.222.219.219 0 0 0 .217 0 .219.219 0 0 0 0 .222a.219.219 0 0 0 .217.221z",
    className: "prefix__cls-3",
    transform: "translate(1.084 1.116)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Oval-2",
    d: "M.217.443A.219.219 0 0 0 .434.222.219.219 0 0 0 .217 0 .219.219 0 0 0 0 .222a.219.219 0 0 0 .217.221z",
    className: "prefix__cls-3",
    "data-name": "Oval",
    transform: "translate(4.429 1.116)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Oval-3",
    d: "M.217.443A.219.219 0 0 0 .434.222.219.219 0 0 0 .217 0 .219.219 0 0 0 0 .222a.219.219 0 0 0 .217.221z",
    className: "prefix__cls-3",
    "data-name": "Oval",
    transform: "translate(11.122 1.116)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Oval-4",
    d: "M.217.443A.219.219 0 0 0 .434.222.219.219 0 0 0 .217 0 .219.219 0 0 0 0 .222a.219.219 0 0 0 .217.221z",
    className: "prefix__cls-3",
    "data-name": "Oval",
    transform: "translate(4.429 4.546)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Oval-5",
    d: "M.217.443A.219.219 0 0 0 .434.222.219.219 0 0 0 .217 0 .219.219 0 0 0 0 .222a.219.219 0 0 0 .217.221z",
    className: "prefix__cls-3",
    "data-name": "Oval",
    transform: "translate(11.122 4.546)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Oval-6",
    d: "M.217.443A.219.219 0 0 0 .434.222.219.219 0 0 0 .217 0 .219.219 0 0 0 0 .222a.219.219 0 0 0 .217.221z",
    className: "prefix__cls-3",
    "data-name": "Oval",
    transform: "translate(1.084 4.546)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Oval-7",
    d: "M.217.443A.219.219 0 0 0 .434.222.219.219 0 0 0 .217 0 .219.219 0 0 0 0 .222a.219.219 0 0 0 .217.221z",
    className: "prefix__cls-3",
    "data-name": "Oval",
    transform: "translate(7.774 4.546)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Oval-8",
    d: "M.217.443A.219.219 0 0 0 .434.222.219.219 0 0 0 .217 0 .219.219 0 0 0 0 .222a.219.219 0 0 0 .217.221z",
    className: "prefix__cls-3",
    "data-name": "Oval",
    transform: "translate(14.467 4.546)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Oval-9",
    d: "M.217.443A.219.219 0 0 0 .434.222.219.219 0 0 0 .217 0 .219.219 0 0 0 0 .222a.219.219 0 0 0 .217.221z",
    className: "prefix__cls-3",
    "data-name": "Oval",
    transform: "translate(7.774 1.116)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Oval-10",
    d: "M.217.443A.219.219 0 0 0 .434.222.219.219 0 0 0 .217 0 .219.219 0 0 0 0 .222a.219.219 0 0 0 .217.221z",
    className: "prefix__cls-3",
    "data-name": "Oval",
    transform: "translate(14.467 1.116)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Oval-11",
    d: "M.217.443A.219.219 0 0 0 .434.222.219.219 0 0 0 .217 0 .219.219 0 0 0 0 .222a.219.219 0 0 0 .217.221z",
    className: "prefix__cls-3",
    "data-name": "Oval",
    transform: "translate(4.429 7.976)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Oval-12",
    d: "M.217.443A.219.219 0 0 0 .434.222.219.219 0 0 0 .217 0 .219.219 0 0 0 0 .222a.219.219 0 0 0 .217.221z",
    className: "prefix__cls-3",
    "data-name": "Oval",
    transform: "translate(7.774 7.976)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Oval-13",
    d: "M.217.443A.219.219 0 0 0 .434.222.219.219 0 0 0 .217 0 .219.219 0 0 0 0 .222a.219.219 0 0 0 .217.221z",
    className: "prefix__cls-3",
    "data-name": "Oval",
    transform: "translate(11.122 7.976)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Oval-14",
    d: "M.217.443A.219.219 0 0 0 .434.222.219.219 0 0 0 .217 0 .219.219 0 0 0 0 .222a.219.219 0 0 0 .217.221z",
    className: "prefix__cls-3",
    "data-name": "Oval",
    transform: "translate(14.467 7.976)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Oval-15",
    d: "M.217.443A.219.219 0 0 0 .434.222.219.219 0 0 0 .217 0 .219.219 0 0 0 0 .222a.219.219 0 0 0 .217.221z",
    className: "prefix__cls-3",
    "data-name": "Oval",
    transform: "translate(1.084 11.408)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Oval-16",
    d: "M.217.443A.219.219 0 0 0 .434.222.219.219 0 0 0 .217 0 .219.219 0 0 0 0 .222a.219.219 0 0 0 .217.221z",
    className: "prefix__cls-3",
    "data-name": "Oval",
    transform: "translate(7.774 11.408)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Oval-17",
    d: "M.217.443A.219.219 0 0 0 .434.222.219.219 0 0 0 .217 0 .219.219 0 0 0 0 .222a.219.219 0 0 0 .217.221z",
    className: "prefix__cls-3",
    "data-name": "Oval",
    transform: "translate(11.122 11.408)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Oval-18",
    d: "M.217.443A.219.219 0 0 0 .434.222.219.219 0 0 0 .217 0 .219.219 0 0 0 0 .222a.219.219 0 0 0 .217.221z",
    className: "prefix__cls-3",
    "data-name": "Oval",
    transform: "translate(14.467 11.408)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Oval-19",
    d: "M.217.443A.219.219 0 0 0 .434.222.219.219 0 0 0 .217 0 .219.219 0 0 0 0 .222a.219.219 0 0 0 .217.221z",
    className: "prefix__cls-3",
    "data-name": "Oval",
    transform: "translate(4.429 11.408)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Oval-20",
    d: "M.217.443A.219.219 0 0 0 .434.222.219.219 0 0 0 .217 0 .219.219 0 0 0 0 .222a.219.219 0 0 0 .217.221z",
    className: "prefix__cls-3",
    "data-name": "Oval",
    transform: "translate(7.774 14.838)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Oval-21",
    d: "M.217.443A.219.219 0 0 0 .434.222.219.219 0 0 0 .217 0 .219.219 0 0 0 0 .222a.219.219 0 0 0 .217.221z",
    className: "prefix__cls-3",
    "data-name": "Oval",
    transform: "translate(14.467 14.838)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Oval-22",
    d: "M.217.443A.219.219 0 0 0 .434.222.219.219 0 0 0 .217 0 .219.219 0 0 0 0 .222a.219.219 0 0 0 .217.221z",
    className: "prefix__cls-3",
    "data-name": "Oval",
    transform: "translate(1.084 14.838)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Oval-23",
    d: "M.217.443A.219.219 0 0 0 .434.222.219.219 0 0 0 .217 0 .219.219 0 0 0 0 .222a.219.219 0 0 0 .217.221z",
    className: "prefix__cls-3",
    "data-name": "Oval",
    transform: "translate(4.429 14.838)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Oval-24",
    d: "M.217.443A.219.219 0 0 0 .434.222.219.219 0 0 0 .217 0 .219.219 0 0 0 0 .222a.219.219 0 0 0 .217.221z",
    className: "prefix__cls-3",
    "data-name": "Oval",
    transform: "translate(11.122 14.838)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Oval-25",
    d: "M.217.443A.219.219 0 0 0 .434.222.219.219 0 0 0 .217 0 .219.219 0 0 0 0 .222a.219.219 0 0 0 .217.221z",
    className: "prefix__cls-3",
    "data-name": "Oval",
    transform: "translate(1.084 18.268)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Oval-26",
    d: "M.217.443A.219.219 0 0 0 .434.222.219.219 0 0 0 .217 0 .219.219 0 0 0 0 .222a.219.219 0 0 0 .217.221z",
    className: "prefix__cls-3",
    "data-name": "Oval",
    transform: "translate(4.429 18.268)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Oval-27",
    d: "M.217.443A.219.219 0 0 0 .434.222.219.219 0 0 0 .217 0 .219.219 0 0 0 0 .222a.219.219 0 0 0 .217.221z",
    className: "prefix__cls-3",
    "data-name": "Oval",
    transform: "translate(7.774 18.268)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Oval-28",
    d: "M.217.443A.219.219 0 0 0 .434.222.219.219 0 0 0 .217 0 .219.219 0 0 0 0 .222a.219.219 0 0 0 .217.221z",
    className: "prefix__cls-3",
    "data-name": "Oval",
    transform: "translate(11.122 18.268)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Oval-29",
    d: "M.217.443A.219.219 0 0 0 .434.222.219.219 0 0 0 .217 0 .219.219 0 0 0 0 .222a.219.219 0 0 0 .217.221z",
    className: "prefix__cls-3",
    "data-name": "Oval",
    transform: "translate(14.467 18.268)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Oval-30",
    d: "M.217.443A.219.219 0 0 0 .434.222.219.219 0 0 0 .217 0 .219.219 0 0 0 0 .222a.219.219 0 0 0 .217.221z",
    className: "prefix__cls-3",
    "data-name": "Oval",
    transform: "translate(14.467 21.7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Oval-31",
    d: "M.217.443A.219.219 0 0 0 .434.222.219.219 0 0 0 .217 0 .219.219 0 0 0 0 .222a.219.219 0 0 0 .217.221z",
    className: "prefix__cls-3",
    "data-name": "Oval",
    transform: "translate(4.429 21.7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Oval-32",
    d: "M.217.443A.219.219 0 0 0 .434.222.219.219 0 0 0 .217 0 .219.219 0 0 0 0 .222a.219.219 0 0 0 .217.221z",
    className: "prefix__cls-3",
    "data-name": "Oval",
    transform: "translate(1.084 7.976)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Oval-33",
    d: "M.217.443A.219.219 0 0 0 .434.222.219.219 0 0 0 .217 0 .219.219 0 0 0 0 .222a.219.219 0 0 0 .217.221z",
    className: "prefix__cls-3",
    "data-name": "Oval",
    transform: "translate(1.084 21.7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Oval-34",
    d: "M.217.443A.219.219 0 0 0 .434.222.219.219 0 0 0 .217 0 .219.219 0 0 0 0 .222a.219.219 0 0 0 .217.221z",
    className: "prefix__cls-3",
    "data-name": "Oval",
    transform: "translate(7.774 21.7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Oval-35",
    d: "M.217.443A.219.219 0 0 0 .434.222.219.219 0 0 0 .217 0 .219.219 0 0 0 0 .222a.219.219 0 0 0 .217.221z",
    className: "prefix__cls-3",
    "data-name": "Oval",
    transform: "translate(11.122 21.7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Oval-36",
    d: "M.217.443A.219.219 0 0 0 .434.222.219.219 0 0 0 .217 0 .219.219 0 0 0 0 .222a.219.219 0 0 0 .217.221z",
    className: "prefix__cls-3",
    "data-name": "Oval",
    transform: "translate(1.084 25.13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Oval-37",
    d: "M.217.443A.219.219 0 0 0 .434.222.219.219 0 0 0 .217 0 .219.219 0 0 0 0 .222a.219.219 0 0 0 .217.221z",
    className: "prefix__cls-3",
    "data-name": "Oval",
    transform: "translate(4.429 25.13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Oval-38",
    d: "M.217.443A.219.219 0 0 0 .434.222.219.219 0 0 0 .217 0 .219.219 0 0 0 0 .222a.219.219 0 0 0 .217.221z",
    className: "prefix__cls-3",
    "data-name": "Oval",
    transform: "translate(7.774 25.13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Oval-39",
    d: "M.217.443A.219.219 0 0 0 .434.222.219.219 0 0 0 .217 0 .219.219 0 0 0 0 .222a.219.219 0 0 0 .217.221z",
    className: "prefix__cls-3",
    "data-name": "Oval",
    transform: "translate(11.119 25.13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Oval-40",
    d: "M.217.443A.219.219 0 0 0 .434.222.219.219 0 0 0 .217 0 .219.219 0 0 0 0 .222a.219.219 0 0 0 .217.221z",
    className: "prefix__cls-3",
    "data-name": "Oval",
    transform: "translate(14.467 25.13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Oval-41",
    d: "M.217.443A.219.219 0 0 0 .434.222.219.219 0 0 0 .217 0 .219.219 0 0 0 0 .222a.219.219 0 0 0 .217.221z",
    className: "prefix__cls-3",
    "data-name": "Oval",
    transform: "translate(1.084 28.56)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Oval-42",
    d: "M.217.443A.219.219 0 0 0 .434.222.219.219 0 0 0 .217 0 .219.219 0 0 0 0 .222a.219.219 0 0 0 .217.221z",
    className: "prefix__cls-3",
    "data-name": "Oval",
    transform: "translate(4.429 28.56)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Oval-43",
    d: "M.217.443A.219.219 0 0 0 .434.222.219.219 0 0 0 .217 0 .219.219 0 0 0 0 .222a.219.219 0 0 0 .217.221z",
    className: "prefix__cls-3",
    "data-name": "Oval",
    transform: "translate(7.774 28.56)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Oval-44",
    d: "M.217.443A.219.219 0 0 0 .434.222.219.219 0 0 0 .217 0 .219.219 0 0 0 0 .222a.219.219 0 0 0 .217.221z",
    className: "prefix__cls-3",
    "data-name": "Oval",
    transform: "translate(11.122 28.56)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Oval-45",
    d: "M.217.443A.219.219 0 0 0 .434.222.219.219 0 0 0 .217 0 .219.219 0 0 0 0 .222a.219.219 0 0 0 .217.221z",
    className: "prefix__cls-3",
    "data-name": "Oval",
    transform: "translate(14.467 28.56)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Shape-2",
    d: "M.862 1.767A.873.873 0 0 1 0 .883.873.873 0 0 1 .862 0a.873.873 0 0 1 .862.883.875.875 0 0 1-.862.883z",
    className: "prefix__cls-4",
    "data-name": "Shape",
    transform: "translate(7.139 7.325)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Shape-3",
    d: "M.862 1.767a.862.862 0 0 1-.8-.545.9.9 0 0 1 .19-.963.846.846 0 0 1 .939-.192.884.884 0 0 1 .532.816.875.875 0 0 1-.862.883z",
    className: "prefix__cls-4",
    "data-name": "Shape",
    transform: "translate(.439 14.187)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Shape-4",
    d: "M.862 1.767a.862.862 0 0 1-.8-.545.9.9 0 0 1 .19-.963.846.846 0 0 1 .939-.192.884.884 0 0 1 .532.816.875.875 0 0 1-.862.883z",
    className: "prefix__cls-4",
    "data-name": "Shape",
    transform: "translate(13.822 14.187)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Shape-5",
    d: "M.862 1.767A.873.873 0 0 1 0 .883.873.873 0 0 1 .862 0a.873.873 0 0 1 .862.883.875.875 0 0 1-.862.883z",
    className: "prefix__cls-4",
    "data-name": "Shape",
    transform: "translate(7.139 21.046)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Shape-6",
    fill: "url(#prefix__linear-gradient)",
    d: "M1.155 0a1.166 1.166 0 0 1 .829.351l6.7 6.862a1.226 1.226 0 0 1 .445 1.226 1.2 1.2 0 0 1-.9.925 1.166 1.166 0 0 1-1.2-.456L.331 2.05A1.233 1.233 0 0 1 .09.747 1.181 1.181 0 0 1 1.159 0z",
    "data-name": "Shape",
    transform: "translate(0 20.603)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Shape-7",
    d: "M1.159 5.971A1.181 1.181 0 0 1 .09 5.225a1.233 1.233 0 0 1 .241-1.3L3.685.484a1.166 1.166 0 0 1 1.2-.456 1.2 1.2 0 0 1 .9.925 1.226 1.226 0 0 1-.445 1.226L1.983 5.616a1.152 1.152 0 0 1-.824.356z",
    className: "prefix__cls-6",
    "data-name": "Shape",
    transform: "translate(10.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Shape-8",
    d: "M14.7 16.258a1.166 1.166 0 0 1-.829-.351L.626 2.292a1.226 1.226 0 0 1-.445-1.226 1.2 1.2 0 0 1 .9-.925A1.166 1.166 0 0 1 2.278.6L15.52 14.212a1.233 1.233 0 0 1 .241 1.3 1.181 1.181 0 0 1-1.069.747z",
    className: "prefix__cls-6",
    "data-name": "Shape",
    transform: "translate(-.019 6.866)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Shape-9",
    d: "M1.159 9.154A1.181 1.181 0 0 1 .09 8.408 1.233 1.233 0 0 1 .331 7.1L7.024.242a1.159 1.159 0 0 1 1.542.112 1.233 1.233 0 0 1 .11 1.582L1.983 8.8a1.166 1.166 0 0 1-.824.356z",
    className: "prefix__cls-6",
    "data-name": "Shape",
    transform: "translate(.134 .247)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKiddyLogo);
export default __webpack_public_path__ + "static/media/kiddy-logo.4052d761c7617da32f475aa50aebc6c6.svg";
export { ForwardRef as ReactComponent };